import React, { useState } from "react"

// WDCE-199 step 9g-3b (D56): the EFTPOS panel on the POS checkout. It renders eftpos/panelView.js's view and decides
// nothing itself: FoodTableOrder works out the view, and onPay and onKey do the requests (eftpos/panelActions.js). Its
// only state is the text typed for the Auth key.
export default ({ view, onPay, onKey }) => {
  const [authText, setAuthText] = useState("")

  if (!view) return null

  return (
    <div className="eftpos-panel card mb-3">
      <div className="card-body">
        <h3 className="eftpos-panel-heading">{view.heading}</h3>
        {view.lines.map((line, index) => <p key={index}>{line}</p>)}
        {view.amountLine && <p><strong>{view.amountLine}</strong></p>}
        {view.displayLines.length > 0 && <pre className="eftpos-panel-display">{view.displayLines.join("\n")}</pre>}

        {view.keys.length > 0 && (
          <div className="eftpos-panel-keys mb-2">
            {view.keys.map(button => (
              <span key={button.key} className="mr-2">
                {button.textBox && (
                  <input
                    type="text"
                    maxLength={button.maxLength}
                    value={authText}
                    onChange={e => setAuthText(e.target.value)}
                    disabled={button.disabled}
                    aria-label={button.label}
                    className="mr-1"
                  />
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={button.disabled}
                  onClick={() => (button.textBox ? onKey(button.key, authText) : onKey(button.key))}
                >{button.label}</button>
              </span>
            ))}
          </div>
        )}
        {view.keyMessage && <p className="eftpos-panel-key-message">{view.keyMessage}</p>}

        {view.adminLink && (
          <p><a href={view.adminLink} target="_blank" rel="noopener noreferrer">Open in admin</a></p>
        )}

        {view.pay.shown && (
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-primary btn-lg text-uppercase"
              disabled={!view.pay.enabled}
              onClick={onPay}
            >{view.pay.label}</button>
            {view.pay.blockedReason && <p className="eftpos-panel-blocked">{view.pay.blockedReason}</p>}
          </div>
        )}
      </div>
    </div>
  )
}
